import { render, staticRenderFns } from "./TemplateManage.vue?vue&type=template&id=304b4a1e&scoped=true&"
import script from "./TemplateManage.vue?vue&type=script&lang=js&"
export * from "./TemplateManage.vue?vue&type=script&lang=js&"
import style0 from "./TemplateManage.vue?vue&type=style&index=0&id=304b4a1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304b4a1e",
  null
  
)

export default component.exports